<script lang="ts" setup>
	import { ChevronDownIcon } from '@heroicons/vue/24/solid'
	import { v4 as uid } from 'uuid'

	const { name, id = uid(), dense = false, defaultOpened = false } = defineProps<{
		id?: string
		name?: string
		as?: string
		label?: string
		headerClass?: string
		expandIcon?: string
		expandedIcon?: string
		switchToggleSide?: boolean,
		split?: boolean
		dense?: boolean,
		defaultOpened?: boolean
	}>()
	const emit = defineEmits(['show', 'hide'])
	const modelValue = defineModel({required: false, local: true})
	const open = ref(modelValue.value || defaultOpened || false)
	const accordion = inject('accordion', false)

	const btnAttrs = computed(() => {
		return  {
			type: 'button',
			'aria-expanded': open.value,
			'aria-controls': id,
			'data-headlessui-state': open.value ? 'open' : '',
			onClick: () => open.value = !open.value
		}
	})

	if (accordion && open.value)
		accordion.value = name || id

	watch(open, (nv: boolean) => {
		modelValue.value = nv
		if (accordion) {
			if (nv)
				accordion.value = name || id
			else {
				if ([name,id].includes(accordion.value))
					accordion.value = undefined
			}

		}
	})
	if (accordion)
		watch(accordion, (nv: string) => {
			if (![name, id].includes(nv) && open.value) open.value = false
		})

	defineExpose({ identifier: name || id, open })
</script>

<template>
	<component :is="as || 'div'">
		<GsItem
			:as="split ? undefined : 'button'"
			:class="headerClass"
			:clickable="!split"
			:dense="dense"
			v-bind="!split ? btnAttrs : {}"
		>
			<GsItemSection v-if="switchToggleSide" side>
				<component :is="split ? 'button' : 'div'" v-bind="split ? btnAttrs : {}" :class="['flex justify-center -ml-3', dense ? 'px-3 py-2 -my-2' : 'p-3 -my-3']">
					<GsIcon v-if="expandIcon && !open" :name="expandIcon" class="w-5 h-5" />
					<GsIcon v-else-if="expandedIcon && open" :name="expandedIcon" class="w-5 h-5" />
					<ChevronDownIcon v-else class="w-5 h-5 transition-all duration-200" :class="{ 'rotate-180': open}" />
				</component>
			</GsItemSection>
			<slot name="title" :open="open" :show="() => open = true" :hide="() => open = false" :id="id">
			<GsItemSection>
				{{ label }}
			</GsItemSection>
			</slot>
			<GsItemSection v-if="!switchToggleSide" side>
				<component :is="split ? 'button' : 'div'" v-bind="split ? btnAttrs : {}" :class="['flex justify-center -mr-3', dense ? 'px-3 py-2 -my-2' : 'p-3 -my-3']">
					<GsIcon v-if="expandIcon && !open" :name="expandIcon" class="h-5 w-5"/>
					<GsIcon v-else-if="expandedIcon && open" :name="expandedIcon" class="h-5 w-5" />
					<ChevronDownIcon v-else class="w-5 h-5 transition-all duration-200" :class="{ 'rotate-180': open}" />
				</component>
			</GsItemSection>
		</GsItem>
		<UCollapsible v-model="open">
			<div v-show="open" :id="id">
				<slot :open="open" :show="() => open = true" :hide="() => open = false" :id="id" />
			</div>
		</UCollapsible>
	</component>
</template>
